import { RouteConfig } from 'vue-router';

const screen: RouteConfig = {
  path: '/screen',
  component: () => import('../views/screen/screen.vue'),
  meta: {
    title: '数据开发中心'
  },
  children: [
    {
      path: '/screen/alert',
      meta: {
        title: '预警监控大屏'
      },
      component: () => import('../views/screen/alert/index.vue')
    },
    {
      path: '/screen/indicator',
      meta: {
        title: '卓越运营指标监控大屏'
      },
      component: () => import('../views/screen/indicator/index.vue')
    }
  ]
};

export default screen;
